const CampaignBounds = () => import('@/modules/campaignBounds');

export default [
  {
    path: '/franquia/destaques/:id/:name/vinculos/',
    component: CampaignBounds,
    name: 'franchise-campaign-bounds',
    meta: {
      navbarTitle: 'Lista de vínculos',
      drawerComponent: () => import('@/modules/campaignBounds/_components/BoundEditForm/index.vue'),
    },
  },
  {
    path: '/destaques/:id/:name/vinculos/',
    component: CampaignBounds,
    name: 'campaign-bounds',
    meta: {
      navbarTitle: 'Lista de vínculos',
      drawerComponent: () => import('@/modules/campaignBounds/_components/BoundEditForm/index.vue'),
    },
  },
];
